// Perfil do embarcador no GoBID (épico PO1-3527; H2 PO1-3529): o bloco "Quem
// está contratando" que as transportadoras de fora da carteira veem no convite
// do leilão e do BID. Mesmo molde do leilaoFreteApi: `embarcadorId` do seletor
// do cabeçalho vai em toda chamada e o backend confere o escopo.
import api from "./api";

// { perfil|null, cadastro, cidadesFiliais, cidadesSelecionadas, opcoes, contatoPadrao }
export async function obterPerfil(embarcadorId) {
  const { data } = await api.get("/gobid/perfil", { params: { embarcadorId } });
  return data;
}

// Grava o perfil inteiro (o que está na tela é o que fica salvo). Devolve o
// mesmo formato do obterPerfil.
export async function salvarPerfil(embarcadorId, campos) {
  const { data } = await api.put("/gobid/perfil", { ...campos, embarcadorId });
  return data;
}

// Prévia do bloco público com os valores ainda não salvos. fluxo: 'leilao' | 'bid'.
export async function previaPerfil(embarcadorId, fluxo, campos) {
  const { data } = await api.post("/gobid/perfil/previa", { ...campos, embarcadorId, fluxo });
  return data && data.perfilEmbarcador ? data.perfilEmbarcador : null;
}

// Só admin Everlog: selo "Verificado pela Everlog".
export async function definirVerificado(embarcadorId, verificado) {
  const { data } = await api.put(`/gobid/perfil/${embarcadorId}/verificado`, { verificado: Boolean(verificado) });
  return data;
}

// Lista de UFs para o seletor de cidades de origem (mesmo endpoint do BID).
export async function listarEstados() {
  const { data } = await api.get("/frete/estados");
  return Array.isArray(data) ? data : [];
}
